import { Button } from '@arco-design/web-react';
import { IconDelete, IconEdit } from '@arco-design/web-react/icon';

import { VolumeOptionLabel } from '@/components/Workload/storage-settings';

import styles from './index.module.less';
import type { VolumeResourceCardProps } from './types';

/** 云盘 / 共享卷资源卡片：VolumeOptionLabel + 编辑 / 删除操作；可选 children 作同卡扩展区 */
export function VolumeResourceCard({
  value,
  label,
  iconfontName = 'icon-yunpan',
  extraItems,
  canEdit = true,
  canDelete = true,
  onEdit,
  onDelete,
  className,
  labelStyle,
  error,
  children,
}: VolumeResourceCardProps) {
  return (
    <div className={[styles.card, error ? styles.cardError : '', className].filter(Boolean).join(' ')}>
      <div className={styles.cardMain}>
        <VolumeOptionLabel
          iconfontName={iconfontName}
          value={value}
          label={label}
          extraItems={extraItems}
          style={{ flex: 1, ...labelStyle }}
        />
        {canEdit || canDelete ? (
          <div className={styles.cardActions}>
            {canEdit ? <Button iconOnly type="text" icon={<IconEdit />} onClick={onEdit} /> : null}
            {canDelete ? <Button iconOnly type="text" status="danger" icon={<IconDelete />} onClick={onDelete} /> : null}
          </div>
        ) : null}
      </div>
      {children ? <div className={styles.cardFooter}>{children}</div> : null}
    </div>
  );
}
